<template>
	<div class="quarterly-header">
		<div v-if="dateArray.length" class="swiper-wrap">
			<div class="pre-btn" @click="handlePreBtn"><i class="iconfont icon-flip-left"></i></div>
			<swiper class="swiper-box" :options.sync="swiperOptionTop" ref="mySwiper">
				<swiper-slide v-for="(item, index) in dateArray" :key="index">
					<div :class="['year-item', yearActive == item && 'year-active']" @click="changeYear(item)">
						{{ item }}
					</div>
				</swiper-slide>
			</swiper>
			<div class="next-btn" @click="handleNextBtn"><i class="iconfont icon-flip-right"></i></div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
export default {
	data() {
		return {
			swiperOptionTop: {
				slidesPerView: 10,
				spaceBetween: 30,
			}
		};
	}
};
</script>

<script setup>
import { ref } from 'vue';

// 初始化时间
const dateArray = ref([]);
const mySwiper = ref(null);
let yearActive = ref('');

const initYearQuarter = data => {
	dateArray.value = Object.keys(data)
		?.map(year => year)
		?.reverse();

	let target;
	Object.values(data).forEach(item => {
		if (item.find(k => k.isTop)) target = item.find(k => k.isTop);
	});
	yearActive.value = target ? String(target.performanceYear) : dateArray.value?.[0];
	let _index = dateArray.value.findIndex(item => target?.performanceYear == item);
	if (mySwiper.value) mySwiper.value.$swiper.slideTo(_index, 100, false);
};

const handlePreBtn = () => {
	mySwiper.value.$swiper.slidePrev();
};

const handleNextBtn = () => {
	mySwiper.value.$swiper.slideNext();
};

const changeYear = year => {
	yearActive.value = year;
	// 触发年份变化事件，让父组件处理季度选择
	emit('yearChange', { year });
};

// 定义事件
const emit = defineEmits(['yearChange']);

// 暴露方法给父组件调用
defineExpose({
	initYearQuarter,
	yearActive
});
</script>

<style lang="less" scoped>
.quarterly-header {
	.swiper-wrap {
		margin-bottom: 24px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.swiper-box {
			padding: 0 20px;
			flex: 1;
		}
		.year-item {
			width: 90px;
			height: 42px;
			line-height: 42px;
			font-size: 24px;
			color: #1d2129;
			text-align: center;
			cursor: pointer;
		}
		.year-active {
			background: rgba(57, 100, 229, 0.16);
		}
		.pre-btn,
		.next-btn {
			width: 20px;
			height: 20px;
			line-height: 20px;
			text-align: center;
			background: #f6f7f8;
			cursor: pointer;
		}
	}
}
</style> 